export default __webpack_public_path__ + "static/media/wxCode2.ddb7a298.png";